import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MenusBehaviourData, MenusBehaviourTypes } from 'store/modules/menus_behaviour_store/types';
import iconIA from 'assets/images/icone-ia.svg';
import { track } from 'services/tracking';
import { Button } from './styles';

const ChatbotAssistantIcon: React.FC = () => {
  const dispatch = useDispatch();

  const { chatbotAssistant } = useSelector<ApplicationState, MenusBehaviourData>(
    (state) => state.session.menus_behaviour.menus_behaviour,
  );

  return (
    <Button
      type="button"
      className="d-flex text-white align-items-center position-relative"
      onClick={() => {
        dispatch({ type: MenusBehaviourTypes.CLOSE_SIDEBAR });
        if (chatbotAssistant) {
          dispatch({ type: MenusBehaviourTypes.CLOSE_CHATBOT_ASSISTANT });
        } else {
          track('consultor_juridico.abriu_chat', { acao: 'abriu' });
          dispatch({ type: MenusBehaviourTypes.OPEN_CHATBOT_ASSISTANT });
        }
      }}
    >
      <img alt="Icone Consultor Jurídico" src={iconIA} aria-hidden="true" />
      <span className="d-md-inline-block d-none ml-2">Consultor Jurídico</span>
      <span className="icon-ia-badge d-md-inline-block d-none badge badge-success position-absolute">
        2.0
      </span>
    </Button>
  );
};

export default ChatbotAssistantIcon;
